export default __webpack_public_path__ + "static/media/empty-cart.d839eca9.svg";